import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import Hero from 'components/hero/BackgroundAsImage.js';
import Features from 'components/features/DashedBorderSixFeatures';
import MainFeature from 'components/features/TwoColSingleFeatureWithStats2.js';
import Portfolio from 'components/cards/PortfolioTwoCardsWithImage.js';
import FAQ from 'components/faqs/SimpleWithSideImage.js';
import Footer from 'components/footers/MiniCenteredFooter.js';
import customerSupportIllustrationSrc from 'images/customer-support-illustration.svg';

import Team from 'components/team/Team';
import TwoColContactUsWithIllustrationFullForm from 'components/forms/TwoColContactUsWithIllustrationFullForm';
import ChatwootWidget from 'components/chat/ChatwootWidget';

export default () => (
  <>
    <Hero />
    <AnimationRevealPage>
      <MainFeature />
      <ChatwootWidget />
      <Features />
      <Team />
      <Portfolio />
      <FAQ
        imageSrc={customerSupportIllustrationSrc}
        imageContain={true}
        imageShadow={false}
        subheading='Preguntas Frecuentes'
        heading={
          <>
            ¿Tienes <span tw='text-primary-500'>preguntas?</span>
          </>
        }
      />
      <TwoColContactUsWithIllustrationFullForm />
    </AnimationRevealPage>
    <Footer />
  </>
);
